export const getPlatformAPIUrl = (): string => {
  const url = window.PLATFORM_API_URL;
  return `${url}/api`;
};
